import React, { useEffect, useState } from "react";
import { MASQUERADE_ID_CLAIM_KEY } from "@origin-digital/origin-auth";
import { fetchAccessToken } from "@origin-digital/event-dispatcher";
import { shouldAttemptAuthFetch } from "@origin-digital/tal-client-common";
import {
  decodeOriginCustomerIdFromJwt,
  getClaimFromJwt,
} from "../../auth/jwtUtils";
import { MasqueradeBannerView } from "./MasqueradeBannerView";

export const MasqueradeBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [originCustomerId, setOriginCustomerId] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      if (!shouldAttemptAuthFetch()) {
        // Neither this page's manifest requires login, nor does the visitor
        // already have a session cookie — there's no session to check for a
        // masquerade claim, so skip the silent Auth0 attempt entirely. A
        // masquerading agent's session cookie is set the same way a regular
        // login's is, so this doesn't affect the masquerade banner's actual
        // job — it only skips the attempt for genuinely anonymous visitors.
        return;
      }
      const accessTokenResponse = await fetchAccessToken({});
      if (accessTokenResponse) {
        const masqueradeId = getClaimFromJwt(
          accessTokenResponse.accessToken,
          MASQUERADE_ID_CLAIM_KEY
        );
        setOriginCustomerId(
          decodeOriginCustomerIdFromJwt(accessTokenResponse.accessToken)
        );
        if (masqueradeId) {
          setShowBanner(true);
        }
      }
    };
    init();
  }, []);

  return showBanner ? (
    <MasqueradeBannerView originCustomerId={originCustomerId} />
  ) : null;
};
